import React, { useEffect } from "react";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import SwitchButton from "../Reusable/SwitchButton";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import { useNavigate } from "react-router-dom";
import Card from "../Reusable/Card";
import { useForm } from "react-hook-form";
import { tw } from "@careinfo/tailwind";
import ComboboxInput from "../Reusable/comboBox";

const GroupList = (props: any) => {
  const navigate = useNavigate();
  const SERVICE_STORAGE_KEY = "selected_service";
  const { handleIsActive } = props;
  const handleRowClick = (row: any) => {
    navigate(`edit/${row.original.id}`);
  };
  const {
    register,
    formState: { errors },
    setValue,
    getValues,
    watch,
    clearErrors,
  } = useForm<any>({});
  const defaultColumns: any = [
    {
      header: "Group",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Currency",
      accessorKey: "code",
      cell: NACell,
    },

    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsActive}
              />
            }
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsActive}
              />
            }
          />
        </div>
      ),
    },

    // {
    //   header: "Action",
    //   accessorKey: "id",
    //   cell: ({ row, getValue }: any) => (
    //     <AccessControl
    //       children={<TableActionButton editPath={`edit/${getValue()}`} />}
    //       allowedPermissions={["can_update_setting"]}
    //     />
    //   ),
    // },
  ];
  useEffect(() => {
    const storedService = sessionStorage.getItem(SERVICE_STORAGE_KEY);

    if (storedService) {
      try {
        const parsed = JSON.parse(storedService);
        setValue("service", parsed); // restore full object
      } catch (e) {
        console.error("Invalid service in sessionStorage");
      }
    }
  }, []);

  const ServiceType = watch("service");
  useEffect(() => {
    if (ServiceType) {
      sessionStorage.setItem(SERVICE_STORAGE_KEY, JSON.stringify(ServiceType));
    } else {
      sessionStorage.removeItem(SERVICE_STORAGE_KEY);
    }
  }, [ServiceType]);

  return (
    <>
      <Card>
        <div className={tw`grid grid-cols-2 md:grid-cols-4 `}>
          <ComboboxInput
            url={APIS.SERVICE_TYPE}
            props={{ is_active: true }}
            queryKey={"service"}
            errors={errors?.service}
            name={"service"}
            label={"Choose Service Type"}
            setValue={setValue}
            placeholder={"Service Type"}
            getValues={getValues}
            clearErrors={clearErrors}
            returnObject={true}
          />
        </div>
      </Card>
      {ServiceType && (
        <DataTable
          url={`${APIS.LOCATION}`}
          queryKey={`group-${ServiceType}`}
          columns={defaultColumns}
          params={{
            group: true,
            service: ServiceType ? ServiceType?.id : undefined,
          }}
          addNewPagePath={{
            pathname: "/create-group",
            state: {
              service: ServiceType,
            },
          }}
          tableName={"group"}
          onRowClick={handleRowClick}
        />
      )}
    </>
  );
};

export default GroupList;
